export function renderEditPageTemplate({
  singular,
  kebabSingular
}: {
  singular: string
  kebabSingular: string
}): string {
  return `import * as React from 'react'
import { Edit${singular}PageContent } from './edit-${kebabSingular}-page-content'
import { Edit${singular}PageSkeleton } from './edit-${kebabSingular}-page-skeleton'

interface PageProps {
  params: Promise<{
    id: string
  }>
}

export default function Edit${singular}Page({ params }: PageProps) {
  return (
    <React.Suspense fallback={<Edit${singular}PageSkeleton />}>
      <Edit${singular}PageContent params={params} />
    </React.Suspense>
  )
}
`
}
